import { ProductWidgetStore } from './productWidgetStore';
import { getRuntimeStyleParams } from '../commons/styleParamsService';
export function productWidgetController(_a) {
    var context = _a.context, config = _a.config, compId = _a.compId, setProps = _a.setProps, reportError = _a.reportError;
    var productWidgetStore;
    var siteStore = context.siteStore;
    var styleParams = config.style.styleParams, publicData = config.publicData, _b = config.externalId, externalId = _b === void 0 ? '' : _b;
    var getStyleParams = function (newStyleParams) {
        return getRuntimeStyleParams(newStyleParams || styleParams, {
            formFactor: siteStore.formFactor,
            widgetPreset: publicData.COMPONENT && publicData.COMPONENT.presetId,
        });
    };
    return {
        pageReady: function () {
            productWidgetStore = new ProductWidgetStore(getStyleParams(), publicData, setProps, siteStore, externalId, compId, reportError);
            return productWidgetStore.setInitialState().catch(reportError);
        },
        updateConfig: function (_$w, _a) {
            var newStyleParams = _a.style.styleParams, newPublicData = _a.publicData;
            productWidgetStore.updateState(getStyleParams(newStyleParams), newPublicData);
        },
        exports: function () { return ({}); },
    };
}
//# sourceMappingURL=productWidgetController.js.map